export const describeError = (err)=>err instanceof Error ? err.message : String(err);
export const findLatestPersistedFilterUpdate = (messages)=>{
    for(let i = messages.length - 1; i >= 0; i -= 1){
        const message = messages[i];
        if (message.role === 'assistant' && (message.content.type === 'chat-text' || message.content.type === 'bulk-confirmation') && message.content.filterUpdate != null) {
            return message.content.filterUpdate;
        }
    }
    return null;
};
